// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"9a6dc9ba","484":"c0f957b3","786":"239917c8","796":"4a9a8da3","815":"5886c0ac","819":"eaf6d542","974":"8cb088de"}[chunkId] + ".chunk.js";
};